/*
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-03-21 18:08:52
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-08-07 10:18:31
 * @FilePath: /streamline_detail/utils/share.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { cookie } from '@zz-common/zz-utils'
export function setShare(info) {
  const picList = info?.pics ? info.pics.map((d) => 'https:' + d) : []
  const shareuid = cookie.get('uid') || ''

  // title,
  // desc: desc,
  // imageUrl: shareImg,
  // shareUrl: location.href
  const showMsg = {
    title: info.shareTextTitle,
    desc: info.shareTextContent,
    imageUrl: picList && picList[0],
    shareUrl: `${location.href}&isshare=true&shareuid=${shareuid}`
  }

  Object.assign(showMsg, {
    miniAppShare: {
      title: info.shareTextTitle,
      content: info.shareTextContent,
      appId: 'gh_c2980df66965',
      path: `pages/webview/webview?channel=100_mf_to_wechatfriends&isZzShare=1&url=${encodeURIComponent(
        location.href
      )}`,
      pic: picList && picList[0] && picList[0].replace(/\?.*$/g, '?w=100&h=100')
    }
  })

  return showMsg
}

export function setWaShare(info) {
  const picList = info?.pics ? info.pics.map((d) => 'https:' + d) : []
  const showMsg = {
    title: info.shareTextTitle,
    content: info.shareTextContent,
    waImg: picList && picList[0] && picList[0].replace(/\?.*$/g, '?w=100&h=100'),
    url: `pages/webview/webview?channel=100_mf_to_wechatfriends&isZzShare=1&url=${encodeURIComponent(
      location.href
    )}`
  }
  return showMsg
}
